export class WidgetApi {
    constructor(widgetInstance) {
        this._widgetInstance = widgetInstance;
    }
}
